import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CultDashboardDataService {
  protected baseUrl = 'json/dashboard';
  private messageSource = new BehaviorSubject(null);
  private productCategoryMessageSource = new BehaviorSubject(null);
  currentMessage = this.messageSource.asObservable();
  currentProductCategoryMessage = this.productCategoryMessageSource.asObservable();

  constructor(protected http: HttpClient) {
    this.messageSource.next(null);
    this.productCategoryMessageSource.next(null);
  }

  public selectedSalesPerson: string;
  public selectedProductCategory: string;

  setFilter(message: any) {
    this.messageSource.next(message);
  }

  setProductCategory(message: any) {
    this.productCategoryMessageSource.next(message);
  }
}
